export default class ValidationStatus {
   IsValid: boolean = true;
   ErrorMessage: string = "";

   public SetValidationStatus(isValid: boolean, errorMessage: string) {
      this.IsValid = isValid;
      this.ErrorMessage = errorMessage;
   }
}
